const CompletedIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM12.0631 5.52993C12.2454 5.34768 12.2454 5.0522 12.0631 4.86996C11.8809 4.68772 11.5854 4.68772 11.4032 4.86996L6.59981 9.67331L4.59645 7.66996C4.41421 7.48772 4.11873 7.48772 3.93649 7.66996C3.75424 7.8522 3.75424 8.14768 3.93649 8.32993L6.26982 10.6633C6.45207 10.8455 6.74754 10.8455 6.92979 10.6633L12.0631 5.52993Z" fill="#76A9FA"/>
    </svg>
);

export default CompletedIcon;
